export default (questions, index) => {
  const activeQuestion = questions.find(question => question.index === index);

  if (!activeQuestion) {
    // console.warn('No active question found', questions, index);
  }

  return activeQuestion || {};
};
